module.exports = __webpack_public_path__ + "img/serifnew_box07.02744667.jpg";